import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SectionWrapper from '../../components/atoms/SectionWrapper';
import BiddingPostHeader from '../../components/BiddingPosts/details/BiddingPostHeader';
import BiddingPostTabs from '../../components/BiddingPosts/details/BiddingPostTabs';
import BiddingPostInformationTab from '../../components/BiddingPosts/details/BiddingPostInformationTab';
import BiddingPostProposalsTab from '../../components/BiddingPosts/details/BiddingPostProposalsTab';
import BiddingPostHiredTab from '../../components/BiddingPosts/details/BiddingPostHiredTab';
import BiddingPostBreadcrumbs from '../../components/BiddingPosts/details/BiddingPostBreadcrumbs';
import { useGetPostSummaryQuery } from '../../store/services/biddingPostsService';
import { useGetProposalsCountQuery } from '../../store/services/biddingProposalsService';
import { useGetContractsByPostQuery } from '../../store/services/biddingContractsService';

export default function BiddingPostDetailsPage() {
  const { t } = useTranslation();
  const { postId } = useParams<{ postId: string }>();
  const [activeTab, setActiveTab] = useState<'information' | 'proposals' | 'hired'>('information');

  const { data: summaryData, isLoading: isSummaryLoading } = useGetPostSummaryQuery(
    { postId: postId! },
    { skip: !postId },
  );

  const { data: proposalsCountData } = useGetProposalsCountQuery(
    { postId: postId! },
    { skip: !postId },
  );

  const { data: contractsData } = useGetContractsByPostQuery(
    { postId: postId! },
    { skip: !postId },
  );

  const summary = summaryData?.payload;
  const proposalsCount =
    typeof proposalsCountData?.payload === 'number'
      ? proposalsCountData.payload
      : proposalsCountData?.payload?.count ?? summary?.proposalNo ?? 0;
  const hiredCount = contractsData?.payload?.length ?? summary?.hiredNo ?? 0;

  return (
    <SectionWrapper
      title={t('biddingPosts.detailsPageTitle')}
      desc={<BiddingPostBreadcrumbs />}
      data-testid="bidding-post-details-page"
    >
      <div className="space-y-6" data-testid="bidding-post-details-content">
        <BiddingPostHeader
          postId={postId ?? ''}
          summary={summary}
          isLoading={isSummaryLoading}
        />

        <div className="space-y-6" data-testid="bidding-post-tabs-section">
          <BiddingPostTabs
            activeTab={activeTab}
            onTabChange={setActiveTab}
            proposalsCount={proposalsCount}
            hiredCount={hiredCount}
          />

          {activeTab === 'information' && <BiddingPostInformationTab postId={postId ?? ''} />}
          {activeTab === 'proposals' && <BiddingPostProposalsTab />}
          {activeTab === 'hired' && <BiddingPostHiredTab postId={postId ?? ''} />}
        </div>
      </div>
    </SectionWrapper>
  );
}
